import React from "react";
// Import the main component
import { Viewer, Worker } from "@react-pdf-viewer/core";

// Plugins
import { getFilePlugin } from "@react-pdf-viewer/get-file";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";

export const MostrarPdf = ({ documentoByte }) => {
  const getFilePluginInstance = getFilePlugin();

  const base64toBlob = (data) => {
    const bytes = atob(data);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: "application/pdf" });
  };

  const blob = base64toBlob(documentoByte);
  const url = URL.createObjectURL(blob);

  return (
    <div
      style={{
        border: "1px solid rgba(0, 0, 0, 0.3)",
        height: "750px",
      }}
    >
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
        <Viewer plugins={[getFilePluginInstance]} fileUrl={url} />
      </Worker>
    </div>
  );
};
